<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      let time = 0;
      let clientWidth = document.documentElement.clientWidth;
      if (clientWidth <= 1200) {
        return;
      }
      return (() => {
        clearTimeout(time);
        time = setTimeout(() => {
          this.reload();
        }, 1000);
      })();
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function() {
        this.isRouterAlive = true; //再打开
      });
    }
  }
};
</script>

<style>
/* 网站变灰色 */
/* html{
    filter: gray;
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
} */
* {
  padding: 0;
  margin: 0;
  list-style: none;
}
a{
  text-decoration: none;
}
html,
body {
  min-width: 1200px;
  color: #333;
  font-size: 16px;
  overflow-x: hidden;
}
#app {
  width: 100%;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow: hidden;
}
.page-content{
  /* margin-top: 70px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue